// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgChild = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.976 9.985a3.834 3.834 0 0 0-1.993-1.252h-.15a3.598 3.598 0 0 0 1.292-1.318 3.637 3.637 0 0 0-.585-4.353 3.597 3.597 0 0 0-5.101 0 3.637 3.637 0 0 0-1.057 2.565c.002.627.166 1.242.475 1.786.31.545.753 1 1.29 1.32h-.14a3.903 3.903 0 0 0-1.993 1.252 5.895 5.895 0 0 0-.997 3.757c0 .2.079.39.22.531.14.141.33.22.528.22H7.01v.752c0 .73.289 1.431.803 1.948A2.733 2.733 0 0 0 9.75 18h.498c.727 0 1.424-.29 1.938-.807a2.763 2.763 0 0 0 .802-1.948v-.752h1.246a.733.733 0 0 0 .693-.462.745.745 0 0 0 .054-.289 5.834 5.834 0 0 0-1.006-3.757ZM9.99 3.332c.598 0 1.172.239 1.596.663.424.424.663 1 .666 1.602a2.28 2.28 0 0 1-.663 1.608c-.424.426-1 .666-1.6.666a2.256 2.256 0 0 1-1.592-.67 2.28 2.28 0 0 1 .007-3.212 2.251 2.251 0 0 1 1.606-.657h-.02Zm2.242 9.659a.755.755 0 0 0-.747.751v1.503c0 .332-.132.65-.365.885-.234.235-.55.367-.881.367H9.74c-.33 0-.648-.132-.881-.367a1.256 1.256 0 0 1-.365-.885v-1.493a.753.753 0 0 0-.747-.751H6.532a3.68 3.68 0 0 1 .648-2.004c.438-.541 1.235-1.002 2.81-1.002 1.574 0 2.371.41 2.81 1.002A3.6 3.6 0 0 1 13.458 13l-1.226-.01Z"
    />
  </svg>
)

export default SvgChild
